import { Column } from 'react-table';

import { IPdfUsageTableData } from './PdfTableView.interfaces';

import { ExternalLink } from '../../../../ExternalLink';

const TABLE_COLUMNS_PDF: ReadonlyArray<Column<IPdfUsageTableData>> = [
  {
    accessor: 'dateLocaleDateString',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>Date</div>,
  },
  {
    accessor: 'count',
    Cell: ({ value }) => <div>{value}</div>,
    Header: () => <div>PDFs generated</div>,
  },
  {
    accessor: 'url',
    Cell: ({ value }) => <ExternalLink href={value} isLinkVisible isTooltipVisible />,
    Header: () => <div>Referrer</div>,
  },
  {
    accessor: 'apiKey',
    Cell: ({ value: { title } }) => <div>{title}</div>,
    Header: () => <div>API key</div>,
  },
];


export { TABLE_COLUMNS_PDF };
